import { useInfiniteQuery } from 'react-query'
import { useDispatch, useSelector } from 'react-redux'
import { enqueueSnackbar } from '../../root/actions'
import { getSagasMsgs } from '../../root/selectors'
import { getNotProcessedPicturesRequest } from '../api/tomApi'
import { take } from '../utils/constants'
import { isLastPage } from '../utils/isLastPage'
import { UserPermissions } from 'web/src/services/permissions'

export const useNotProcessed = (key, customTake, isRefetch) => {
    if (!UserPermissions.device().read) {
        return { data: null, isLoading: false, error: null }
    }

    const dispatch = useDispatch()
    const sagasMsgs = useSelector(getSagasMsgs)

    return useInfiniteQuery(
        key || 'notProcessedPictures',
        ({ pageParam = 0 }) =>
            getNotProcessedPicturesRequest({
                take: customTake || take,
                skip: pageParam,
                with_report_types: 1,
                is_assigned: true
            }),
        {
            getNextPageParam: (lastPage, pages) => isLastPage(lastPage, take),
            onError: e =>
                dispatch(
                    enqueueSnackbar({
                        message: sagasMsgs.getTomPicturesEx,
                        options: {
                            variant: 'error'
                        }
                    })
                ),
            cacheTime: 0,
            refetchOnWindowFocus: false,
            refetchInterval: isRefetch ? 20000 : false
        }
    )
}
